import React from 'react'
import { Row, Col, Section } from 'components/Layout'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const SectionRow = styled(Row)`
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  ${media.lg`
    flex-direction: row;
  `}
`

const SectionTitleCol = styled(Col)`
  ${media.lg`
    width: 60%;
  `}
`

const SectionTitle = styled.h2`
  margin: 6px 0;
  padding-right: 48px;
`

const DataPrivacySlice = () => {
  const sliceContent = {
    title: 'Data Privacy',
    subtitle:
      '<p class="p1"><span class="s1">Contains types of information that is collected and recorded by semplates.io and how we use it.</span></p>\n' +
      '<p class="p2"><span class="s1"></span></p>\n' +
      '<p class="p1"><span class="s1">If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. Our Privacy Policy was generated with the help of GDPR Privacy Policy Generator from GDPRPrivacyNotice.com</span></p>',
    sections: [
      {
        title: 'General data protection regulation (GDPR)',
        text:
          '<p class="p1"><span class="s1">We are a Data Controller of your information.</span></p>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<p class="p1"><span class="s1">Semplates legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Information we collect and the specific context in which we collect the information:</span></p>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<ul class="ul1">\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">Semplates needs to perform a contract with you</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">You have given Semplates permission to do so</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">Processing your personal information is in Semplates legitimate interests</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">Semplates needs to comply with the law</span></li>\n' +
          '</ul>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<p class="p1"><span class="s1">Semplates will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.</span></p>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<p class="p1"><span class="s1">If you are a resident of the European Economic Area (EEA), you have certain data protection rights. If you wish to be informed what Personal Information we hold about you and if you want it to be removed from our systems, please contact us.</span></p>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<ul class="ul1">\n' +
          '  <li class="li1"><span class="s1">In certain circumstances, you have the following data protection rights:</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">The right to access, update or to delete the information we have on you.</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">The right of rectification.</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">The right to object.</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">The right of restriction.</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">The right to data portability</span></li>\n' +
          '  <li class="li1"><span class="s2"></span><span class="s1">The right to withdraw consent</span></li>\n' +
          '</ul>',
      },
      {
        title: 'Log Files',
        text: '<p class="p1">semplates.io follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services\' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users\' movement on the website, and gathering demographic information.</p>',
      },
      {
        title: 'Cookies and web beacons',
        text:
          "<p class=\"p1\">Like any other website, semplates.io uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.</p>\n" +
          '<p class="p1">For more general information on cookies, please read "What Are Cookies".</p>',
      },
      {
        title: 'Privacy policies',
        text:
          '<p class="p1">You may consult this list to find the Privacy Policy for each of the advertising partners of semplates.io.</p>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<p class="p1">Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on semplates.io, which are sent directly to users\' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>\n' +
          '<p class="p2"><span class="s1"></span></p>\n' +
          '<p class="p1">Note that semplates.io has no access to or control over these cookies that are used by third-party advertisers.</p>\n',
      },
      {
        title: 'Third party privacy policies',
        text:
          '<p class="p1"><span class="s1">semplates.io\'s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>\n' +
          '<p class="p1"><span class="s1">You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers\' respective websites.</p>\n',
      },
      {
        title: "Children's information",
        text:
          '<p class="p1">Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>\n' +
          '<p class="p1">semplates.io does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>',
      },
      {
        title: 'Online pricacy policy only',
        text: '<p class="p1">Our Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in semplates.io. This policy is not applicable to any information collected offline or via channels other than this website.</p>',
      },
      {
        title: 'Consent',
        text: '<p class="p1">By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>',
      },
    ],
  }

  return (
    <Section>
      <Row>
        <Col>
          <h1>{sliceContent.title}</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <div dangerouslySetInnerHTML={{ __html: sliceContent.subtitle }} />
        </Col>
      </Row>
      {sliceContent.sections.map((section, idx) => (
        <SectionRow key={idx}>
          <SectionTitleCol>
            <SectionTitle>{section.title}</SectionTitle>
          </SectionTitleCol>
          <Col>
            <div dangerouslySetInnerHTML={{ __html: section.text }} />
          </Col>
        </SectionRow>
      ))}
    </Section>
  )
}

export default DataPrivacySlice
